import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, } from "@azure/msal-react";
import { getIsCrane, getMsTenantFromUrl, loginRequest } from "../authConfig";
import SetupSelector from "./SetupSelector";
import MainContent from "../layout/MainContent";
import Button from "../components/Button";
import { validateTenantExists } from "../utils/tenantValidation";
import ErrorPage from "../pages/MissingTenantPage";
import { getTranslation } from "../translations";
const AuthWrapper = () => {
    const labels = getTranslation();
    const { instance } = useMsal();
    const [readyToRender, setReadyToRender] = useState(false);
    const [errorPage, setErrorPage] = useState(null);
    const handleRedirect = async () => {
        const tenant = getMsTenantFromUrl();
        const isValid = await validateTenantExists(tenant);
        if (!isValid) {
            setErrorPage(_jsx(ErrorPage, { title: labels.invalidTenant, message: labels.invalidTenantMessage }));
            return;
        }
        sessionStorage.setItem("login_intent_ts", String(Date.now()));
        await instance.loginRedirect(loginRequest);
    };
    const isCrane = getIsCrane();
    if (errorPage)
        return errorPage;
    const content = readyToRender ? (_jsx(MainContent, {})) : (_jsx(SetupSelector, { setReadyToRender: setReadyToRender }));
    return (_jsx("div", { children: isCrane ? (content) : (_jsxs(_Fragment, { children: [_jsx(AuthenticatedTemplate, { children: content }), _jsx(UnauthenticatedTemplate, { children: _jsx("div", { className: "flex items-center justify-center h-screen", children: _jsx(Button, { onClick: handleRedirect, className: "rounded-[var(--radius)] shadow-none cursor-pointer text-[length:var(--text-12)] px-5 pt-[18px] pb-5", type: "button", children: labels.login }) }) })] })) }));
};
export default AuthWrapper;
